import Vue from 'vue'
import { mapGetters,mapActions } from 'vuex';

export default {

	data: () => ({
    parametros:{
      dialogError: false,
      mensaje: '',
      color: ''
    },

    respuestaAlerta:false,
    loader: true,
    cargar: false,

    tieneAdeudoPaquete: null,
		infoPaqueteAdeudo: null,
		detallesPaqueteAdeudo: null,
		pagoAnterior: 0
  }),

  computed: {
  	...mapGetters('login',['getdatosUsuario']),

    formTitle () {
      return this.editedIndex === -1 ? 'Agregar grupo' : 'Editar grupo'
    },

    pagoPaquete( ){

    	return this.comprarPaquetes.map( item => item.costo_total  ).reduce((prev, curr) => prev + curr, 0)  - this.pagoAnterior

    },

    pagoArticulo( ){

    	return this.comprarArticulos.map(item => item.costo_total  ).reduce((prev, curr) => prev + curr, 0) 

    },

		cambio( ){

			return this.pagado - this.pagoPaquete
		},

		adeudoPaquete( ){

			return this.pagoPaquete - this.pagado 

    },

		cambioArticulo( ){

			return this.pagado - this.pagoArticulo
		},

		cambioGrupo( ){

			return ( parseFloat( this.pagado ) - ( parseFloat( this.total_pagado_grupo )  + parseFloat( this.pago_inscripcion  ))).toFixed( 2 )

		},

		cambioGrupoPagoAnterior( ){

			return ( parseFloat( this.pagado ) - ( parseFloat( this.totalPagarColegiatura ) + parseFloat( this.pago_inscripcion  ) )).toFixed( 2 )

		},

		adeudoColegiatura( ){

			let restante = this.totalPagarColegiatura - this.pagado

			return restante <= 0 ? 0 : ( this.totalPagarColegiatura - this.pagado ).toFixed( 2 )

		},

		filterPagosGruposList( ){

			let data = this.pagosGruposList
			console.log( this.pagosGruposList )
			if( this.plantel ){ data = data.filter( el => el.idplantel == this.plantel ) }
			if( this.cursoSeleccionado ){ data = data.filter( el => el.curso == this.cursoSeleccionado ) }

			return data
		},

		filterPagosPaquetesList( ){

			let data = this.pagosPaquetesList


			if( this.plantel ){ data = data.filter( el => el.idplantel == this.plantel ) }
			
			return data
		},

		filterPagosArticulosList( ){

			for( const i in this.pagosArticulosList ){

				const { detalles } = this.pagosArticulosList[i]

				let detalle = ''

				for( const j in detalles ){

					const { articulo } = detalles[j]

					if( articulo == 'INSCRIPCIÓN' ){ this.pagosArticulosList[i]['insc'] = 1 }else{ this.pagosArticulosList[i]['insc'] = 0 }

					detalle += detalles[j].articulo +  ', '

				}

				this.pagosArticulosList[i]['detalle_articulo'] = detalle

			}

			if( this.plantel ){ return this.pagosArticulosList.filter(el => el.idplantel === this.plantel && !el.insc ) }

			return this.pagosArticulosList.filter(el => !el.insc )
		},

		filterPagosArticulosListInsc( ){
			for( const i in this.pagosArticulosList ){

				const { detalles } = this.pagosArticulosList[i]

				let detalle = ''

				for( const j in detalles ){

					const { articulo } = detalles[j]

					if( articulo == 'INSCRIPCIÓN' ){ this.pagosArticulosList[i]['insc'] = 1 }else{ this.pagosArticulosList[i]['insc'] = 0 }

					detalle += detalles[j].articulo +  ', '

				}

				this.pagosArticulosList[i]['detalle_articulo'] = detalle

			}

			if( this.plantel ){ return this.pagosArticulosList.filter(el => el.idplantel === this.plantel && el.insc ) }

			return this.pagosArticulosList.filter(el => el.insc )
		},


		montoEfectivo( ){

			if( this.tipoPago == 1 ){ return this.filterPagosGruposList.filter( el => el.forma_pago == 1 ).map(item => item.pagado  ).reduce((prev, curr) => prev + curr, 0)  }

			if( this.tipoPago == 2 ){ return this.filterPagosPaquetesList.filter( el => el.forma_pago == 1 ).map(item => item.pagado  ).reduce((prev, curr) => prev + curr, 0)  }

			if( this.tipoPago == 3 ){ return this.filterPagosArticulosList.filter( el => el.forma_pago == 1 ).map(item => item.pagado  ).reduce((prev, curr) => prev + curr, 0)  }

			if( this.tipoPago == 4 ){ return this.filterPagosArticulosListInsc.filter( el => el.forma_pago == 1 ).map(item => item.pagado  ).reduce((prev, curr) => prev + curr, 0)  }

		},

		movimientosEfectivo( ){

			if( this.tipoPago == 1 ){ return this.filterPagosGruposList.filter( el => el.forma_pago == 1 ).length  }

			if( this.tipoPago == 2 ){ return this.filterPagosPaquetesList.filter( el => el.forma_pago == 1 ).length  }

			if( this.tipoPago == 3 ){ return this.filterPagosArticulosList.filter( el => el.forma_pago == 1 ).length  }

			if( this.tipoPago == 4 ){ return this.filterPagosArticulosListInsc.filter( el => el.forma_pago == 1 ).length  }

		},

		montoDeposito( ){

			if( this.tipoPago == 1 ){ return this.filterPagosGruposList.filter( el => el.forma_pago == 2 ).map(item => item.pagado  ).reduce((prev, curr) => prev + curr, 0)  }

			if( this.tipoPago == 2 ){ return this.filterPagosPaquetesList.filter( el => el.forma_pago == 2 ).map(item => item.pagado  ).reduce((prev, curr) => prev + curr, 0)  }

			if( this.tipoPago == 3 ){ return this.filterPagosArticulosList.filter( el => el.forma_pago == 2 ).map(item => item.pagado  ).reduce((prev, curr) => prev + curr, 0)  }

			if( this.tipoPago == 4 ){ return this.filterPagosArticulosListInsc.filter( el => el.forma_pago == 2 ).map(item => item.pagado  ).reduce((prev, curr) => prev + curr, 0)  }

		},

		movimientosDeposito( ){

			if( this.tipoPago == 1 ){ return this.filterPagosGruposList.filter( el => el.forma_pago == 2 ).length  }

			if( this.tipoPago == 2 ){ return this.filterPagosPaquetesList.filter( el => el.forma_pago == 2 ).length  }

			if( this.tipoPago == 3 ){ return this.filterPagosArticulosList.filter( el => el.forma_pago == 2 ).length  }

			if( this.tipoPago == 4 ){ return this.filterPagosArticulosListInsc.filter( el => el.forma_pago == 2 ).length  }

		},

		montoTarjeta( ){

			if( this.tipoPago == 1 ){ return this.filterPagosGruposList.filter( el => el.forma_pago == 3 ).map(item => item.pagado  ).reduce((prev, curr) => prev + curr, 0)  }

			if( this.tipoPago == 2 ){ return this.filterPagosPaquetesList.filter( el => el.forma_pago == 3 ).map(item => item.pagado  ).reduce((prev, curr) => prev + curr, 0)  }

			if( this.tipoPago == 3 ){ return this.filterPagosArticulosList.filter( el => el.forma_pago == 3 ).map(item => item.pagado  ).reduce((prev, curr) => prev + curr, 0)  }

			if( this.tipoPago == 4 ){ return this.filterPagosArticulosListInsc.filter( el => el.forma_pago == 3 ).map(item => item.pagado  ).reduce((prev, curr) => prev + curr, 0)  }

		},

		movimientosTarjeta( ){

			if( this.tipoPago == 1 ){ return this.filterPagosGruposList.filter( el => el.forma_pago == 3 ).length  }

			if( this.tipoPago == 2 ){ return this.filterPagosPaquetesList.filter( el => el.forma_pago == 3 ).length  }

			if( this.tipoPago == 3 ){ return this.filterPagosArticulosList.filter( el => el.forma_pago == 3 ).length  }

			if( this.tipoPago == 4 ){ return this.filterPagosArticulosListInsc.filter( el => el.forma_pago == 3 ).length  }

		},


		montoTotal( ){

			if( this.tipoPago == 1 ){ return this.filterPagosGruposList.map(item => item.pagado  ).reduce((prev, curr) => prev + curr, 0)  }

			if( this.tipoPago == 2 ){ return this.filterPagosPaquetesList.map(item => item.pagado  ).reduce((prev, curr) => prev + curr, 0)  }

			if( this.tipoPago == 3 ){ return this.filterPagosArticulosList.map(item => item.pagado  ).reduce((prev, curr) => prev + curr, 0)  }

			if( this.tipoPago == 4 ){ return this.filterPagosArticulosListInsc.map(item => item.pagado  ).reduce((prev, curr) => prev + curr, 0)  }

		},

		movimientos( ){

			if( this.tipoPago == 1 ){ return this.filterPagosGruposList.length  }

			if( this.tipoPago == 2 ){ return this.filterPagosPaquetesList.length  }

			if( this.tipoPago == 3 ){ return this.filterPagosArticulosList.length  }

			if( this.tipoPago == 4 ){ return this.filterPagosArticulosListInsc.length  }

		},

		totalPagarColegiatura( ){

			console.log (this.grupoAnterior  ) // .pago_recurrente

			if( this.grupoAnterior ){

				const { adeudo } = this.grupoAnterior 

				if( adeudo > 0 ){

					return parseFloat( adeudo ) + parseFloat( this.multa )

				}else{

					return this.grupoAnterior.pago_recurrente

				}


			}

			return 0
		}

  },
  
	methods: {

		async validarAdeudoPaquete( ){

      this.cargar = true;

		  try {

		  	// Si pasa por aquí es que no tiene adeudo
		    const response = await this.$http.get('adeudo.paquetes/' +  this.alumno);

		    this.tieneAdeudoPaquete    = false
		  	this.infoPaqueteAdeudo     = null
		  	this.comprarPaquetes       = []
		  	this.pagoAnterior          = 0
		  	this.pasoPago              = 3

		  } catch (error) {

		  	this.tieneAdeudoPaquete    = true
		  	this.infoPaqueteAdeudo     = error.body.info
		  	this.comprarPaquetes       = error.body.detalles
		  	this.pagoAnterior          = error.body.info.pagado
		  	this.pasoPago              = 3


		  } finally {

		    this.cargar = false;

		  }

		}
  }
}